import { jsx } from "react/jsx-runtime";
import { marked } from "marked";
marked.use({
  gfm: true,
  breaks: true,
  pedantic: false,
  renderer: {
    link({ href, text }) {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="text-decoration:underline;color:inherit;">${text}</a>`;
    }
  }
});
function resolveNumberedRefs(text, sourcesMap) {
  return text.replace(/\[(\d+)\]/g, (_m, num) => {
    const source = sourcesMap.get(num);
    if (!source) return _m;
    const label = source.title || source.url;
    return `[${label}](${source.url})`;
  });
}
function TextPart({
  text,
  sourcesMap
}) {
  if (!text.trim()) return null;
  const processed = (sourcesMap == null ? void 0 : sourcesMap.size) ? resolveNumberedRefs(text, sourcesMap) : text;
  const html = marked.parse(processed);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "message-markdown",
      style: { display: "flex", flexDirection: "column" },
      dangerouslySetInnerHTML: { __html: html }
    }
  );
}
export {
  TextPart
};
//# sourceMappingURL=TextPart.js.map
